/* Manchester · Sistema de tallas compartido — PDP + Quick Add de PLP
   =========================================================================
   Una sola implementación de las reglas que traducen la talla técnica de
   Shopify/NetSuite (TALLA = "14.5-3") a la experiencia del cliente
   (Talla sport → Cuello → Manga).

   Las funciones de parseo y de conversión de manga son PORTADAS TAL CUAL
   desde snippets/manchester-size-grouping.liquid (implementación original de
   Rodrigo en el PDP) para que ambas superficies resuelvan idéntico. El PDP
   las consume desde aquí y conserva las suyas como fallback, así que si este
   archivo no cargara, el PDP sigue funcionando como siempre.

   Los grupos (CH/M/G/XL/1XL/2XL/3XL) NO viven aquí: llegan por
   window.MFG_SIZE_GROUPS desde shop.metafields.manchester.size_groups
   (ver snippets/manchester-size-groups-data.liquid).
   ========================================================================= */
(function () {
  'use strict';

  var API = {};

  /* ------------------------------------------------------------- parseo --
     "14.5-2"   → { collar: "14.5", cuff: "2" }      (corta en el ÚLTIMO guion)
     "15 2-3"   → { collar: "15",   cuff: "2-3" }    (formato con espacio)
     "15-2*"    → isPopular: true                                            */
  API.parseSize = function (sizeStr) {
    if (!sizeStr) return null;
    var isPopular = sizeStr.indexOf('*') !== -1;
    var cleaned = sizeStr.replace('*', '').trim();
    var collar, cuff;

    if (cleaned.indexOf(' ') !== -1) {
      var spaceIdx = cleaned.indexOf(' ');
      collar = cleaned.substring(0, spaceIdx).trim();
      cuff = cleaned.substring(spaceIdx + 1).trim();
    } else {
      var lastDash = cleaned.lastIndexOf('-');
      if (lastDash <= 0) return null;
      collar = cleaned.substring(0, lastDash).trim();
      cuff = cleaned.substring(lastDash + 1).trim();
    }
    if (!collar || !cuff) return null;
    return { collar: collar, cuff: cuff, isPopular: isPopular, original: sizeStr, full: cleaned };
  };

  // Código interno de manga → pulgadas para mostrar. "2" → "32", "2-3" → "32-33".
  API.cuffToInches = function (cuff) {
    if (!cuff) return cuff;
    return String(cuff).replace(/\d+/g, function (n) { return '3' + n; });
  };

  /* ------------------------------------------------------------- grupos -- */

  // Normaliza el string del metafield/bloque a array de códigos TALLA.
  // El replace(/, /g, ',') es necesario: hay entradas como "20-6, 20 4-5"
  // donde el espacio tras la coma no separa cuello de manga.
  API.splitSizes = function (raw) {
    return String(raw || '').replace(/, /g, ',').split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
  };

  API.getGroups = function () {
    var g = window.MFG_SIZE_GROUPS;
    if (!Array.isArray(g) || !g.length) return [];
    return g
      .filter(function (x) { return x && x.acronym && x.sizes; })
      .map(function (x) {
        return { acronym: String(x.acronym).trim(), sizes: API.splitSizes(x.sizes) };
      });
  };

  // ¿El producto usa el sistema técnico de camisa de vestir?
  // Mismo criterio que el PDP: al menos un valor con formato "X.Y-Z" o "X Y-Z".
  API.usesDressShirtSizing = function (values) {
    if (!Array.isArray(values)) return false;
    var n = 0;
    for (var i = 0; i < values.length; i++) {
      if (API.parseSize(values[i])) n++;
    }
    return n >= 2;
  };

  /* --------------------------------------------- resolución de variantes --
     Devuelve la variante EXACTA para (opciones actuales + talla técnica).
     `variants` = objetos con .options (array) y .available.                  */
  API.findVariant = function (variants, optionIndex, currentOptions, fullSize) {
    var candidate = currentOptions.slice();
    candidate[optionIndex] = fullSize;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var ok = true;
      for (var j = 0; j < v.options.length; j++) {
        if (candidate[j] === null || candidate[j] === undefined) continue;
        if (v.options[j] !== candidate[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  };

  /* ------------------------------------------------------------ modelo ---
     Construye el árbol Talla sport → Cuello → Manga para un color concreto,
     con la variante real y su stock en cada hoja. Solo incluye combinaciones
     que EXISTEN como variante del producto: nunca inventa disponibilidad.   */
  API.buildTree = function (opts) {
    var variants = opts.variants;
    var sizeIndex = opts.sizeIndex;
    var baseOptions = opts.baseOptions;      // opciones fijas (p.ej. color)
    var groups = opts.groups || API.getGroups();
    var tree = [];

    groups.forEach(function (g) {
      var collars = {};
      g.sizes.forEach(function (sizeStr) {
        var p = API.parseSize(sizeStr);
        if (!p) return;
        var variant = API.findVariant(variants, sizeIndex, baseOptions, p.full);
        if (!variant) return;                 // esa combinación no existe aquí
        if (!collars[p.collar]) collars[p.collar] = [];
        collars[p.collar].push({
          cuff: p.cuff,
          cuffLabel: API.cuffToInches(p.cuff),
          fullSize: p.full,
          variantId: variant.id,
          available: !!variant.available,
          isPopular: p.isPopular
        });
      });

      var collarList = Object.keys(collars)
        .sort(function (a, b) { return parseFloat(a) - parseFloat(b); })
        .map(function (c) {
          var cuffs = collars[c].sort(function (a, b) {
            return parseInt(a.cuff, 10) - parseInt(b.cuff, 10);
          });
          return {
            collar: c,
            cuffs: cuffs,
            available: cuffs.some(function (x) { return x.available; })
          };
        });

      if (collarList.length) {
        tree.push({
          acronym: g.acronym,
          collars: collarList,
          available: collarList.some(function (c) { return c.available; })
        });
      }
    });

    return tree;
  };

  window.MfgSizeSystem = API;
})();
